module.exports = __webpack_public_path__ + "img/blog-8.2bc3dfc4.jpg";